import { render, staticRenderFns } from "./GoodsLinkCopyDialog.vue?vue&type=template&id=12d6e844&scoped=true"
import script from "./GoodsLinkCopyDialog.vue?vue&type=script&lang=js"
export * from "./GoodsLinkCopyDialog.vue?vue&type=script&lang=js"
import style0 from "./GoodsLinkCopyDialog.vue?vue&type=style&index=0&id=12d6e844&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6e844",
  null
  
)

export default component.exports